import { Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import PlayIcon from './play-icon.svg?react'
import PauseIcon from './pause-icon.svg?react'
import PlayIconFlat from './play-icon-flat.svg?react'
import PauseIconFlat from './pause-icon-flat.svg?react'
import s from './s.module.css'
import { lang } from './lang'

export type AudioPlayerButtonType = 'circle' | 'flat'

interface IAudioPlayerButtonProps {
  type?: AudioPlayerButtonType
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  isPlaying: boolean
}

export default function AudioPlayerButton({ type = 'circle', onClick, isPlaying }: IAudioPlayerButtonProps) {
  if (type === 'circle') {
    return (
      <Button
        shape="circle"
        className={s.icon}
        onClick={onClick}
        ghost
        icon={isPlaying ? <PauseIcon /> : <PlayIcon />}
      />
    )
  } else {
    return (
      <Button
        style={{ padding: 0 }}
        className={s.icon}
        type="link"
        onClick={onClick}
        icon={isPlaying ? <PauseIconFlat /> : <PlayIconFlat />}
      >
        <FormattedMessage {...lang.play} />
      </Button>
    )
  }
}
